import './style.scss';
import { Slider } from '../../../js/components/Slider/Slider';

export default !function () {
  const blocks = document.querySelectorAll('.universal-events');

  if (!blocks.length) {
    return;
  }

  blocks.forEach((block) => {
    const sliderContainer = block.querySelector('.universal-events__slider');

    if (!sliderContainer) {
      return;
    }

    const slides = sliderContainer.querySelectorAll('.universal-events__item');
    const controls = sliderContainer.querySelector('.universal-events__controls');
    const isInit = slides.length > 1;

    const options = {
      wrapper: sliderContainer,
      settings: {
        spaceBetween: 8,
        fadeEffect: {
          crossFade: true
        },

        slideClass: 'universal-events__item',
        wrapperClass: 'universal-events__list',

        pagination: {
          el: '.universal-events__count',
          type: 'fraction',
        },

        navigation: {
          nextEl: '.button-arrow--next',
          prevEl: '.button-arrow--prev'
        },

        media: {
          lg: {
            loop: true,
            effect: 'fade'
          },
          xl: {
            loop: true,
            effect: 'fade'
          }
        },

        breakpoints: {
          1024: {
            spaceBetween: 0,
          }
        }
      },
      modules: ['pagination', 'navigation', 'effectFade', 'a11y'],
      initCondition: {
        sm: isInit,
        md: isInit,
        lg: isInit,
        xl: isInit
      },
      controls
    };

    new Slider(options).init();
  });
}();
